module.exports = __webpack_public_path__ + "img/logo.aaca5449.png";